import { compact } from "lodash";

import { combineReducers } from "redux";

function createSetReducer(eventName) {
  return (s = new Set(), action) => {
    switch (action.type) {
      case eventName:
        return new Set(compact([...action.value]));
      default:
        return s;
    }
  };
}

export const reducer = combineReducers({
  workflows: createSetReducer("NOTIFY_WORKFLOWS"),
  workflowsTemplate: createSetReducer("NOTIFY_WORKFLOWS_TEMPLATE"),
  clientCardTasks: createSetReducer("NOTIFY_CLIENT_CARD_TASKS"),
  clientCardUpcomingReminders: createSetReducer(
    "NOTIFY_CLIENT_CARD_UPCOMING_REMINDERS"
  ),
  addUserCompleted: createSetReducer("NOTIFY_ADD_USER_COMPLETED"),
  addUserCancelled: createSetReducer("NOTIFY_ADD_USER_CANCELLED"),
  changePlanCompleted: createSetReducer("NOTIFY_CHANGE_PLAN_COMPLETED"),
  subscriptionChanged: createSetReducer("NOTIFY_SUBSCRIPTION_CHANGED"),
  nextWorkflows: createSetReducer("NOTIFY_NEXT_WORKFLOWS"),
  clientCardNextWorkflows: createSetReducer(
    "NOTIFY_CLIENT_CARD_NEXT_WORKFLOWS"
  ),
});

export default reducer;
